<template>
  <v-col v-if="!maxValueValid && availableBudget" cols="12" lg="12" sm="12">
    <v-alert v-if="availableBudget" type="error" class="ma-0" outlined text>
      <div>You have £{{ availableBudget.toFixed(2) }} of available budget</div>
      <div>Budget after Purchase: £{{ valueDifference.toFixed(2) }}</div>
      <div>{{ message }}</div>
    </v-alert>
  </v-col>
  <v-col v-else-if="showAvailableBudget != 0" cols="12" lg="12" sm="12">
    <v-alert type="success" class="ma-0" outlined text>
      <div>Available Budget: £{{ availableBudget.toFixed(2) }}</div>
      <div>Budget after Purchase: £{{ valueDifference.toFixed(2) }}</div>
    </v-alert>
  </v-col>
</template>

<script>
export default {
  computed: {
    showAvailableBudget() {
      if (
        this.$store.getters.retrieveIsCashCustomer ||
        this.$store.getters.retrieveIsCncCustomer ||
        this.$store.getters.retrieveIsPaymentWithOrderCustomer
      ) {
        return 0;
      } else {
        if (this.$store.getters.retrieveCurrentTrolly) {
          if (
            Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
              .length > 0
          ) {
            return this.$store.getters.retrieveCurrentTrolly
              .maximum_budget_order.showBudget;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      }
    },

    maxValueValid() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          return this.$store.getters.retrieveCurrentTrolly.maximum_budget_order
            .valid;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    availableBudget() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          return parseFloat(
            this.$store.getters.retrieveCurrentTrolly.maximum_budget_order
              .budgetMax
          );
        } else {
          console.log("- Fail 2");
          return false;
        }
      } else {
        console.log("- Fail 1");
        return false;
      }
    },

    message() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          return this.$store.getters.retrieveCurrentTrolly.maximum_budget_order
            .message;
        } else {
          console.log("- Fail 2");
          return null;
        }
      } else {
        console.log("- Fail 1");
        return null;
      }
    },

    valueDifference() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          return parseFloat(
            this.$store.getters.retrieveCurrentTrolly.maximum_budget_order
              .budgetAfterTrolly
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>